import { useState } from 'react';

export default function FloatingButtons() {
  const [expanded, setExpanded] = useState(true);

  const actions = [
    {
      id: 'whatsapp',
      href: 'https://wa.me/905322376576',
      icon: 'ri-whatsapp-line',
      label: 'WhatsApp',
      bg: 'bg-whatsapp hover:bg-whatsapp-dark',
      external: true,
    },
    {
      id: 'call',
      href: 'tel:+905322376576',
      icon: 'ri-phone-fill',
      label: '+90 532 237 65 76',
      bg: 'bg-brand-orange hover:bg-brand-orange-dark',
      external: false,
    },
    {
      id: 'instagram',
      href: 'https://www.instagram.com',
      icon: 'ri-instagram-line',
      label: 'Instagram',
      bg: '',
      style: { background: 'linear-gradient(135deg, #f09433, #dc2743, #bc1888)' },
      external: true,
    },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Expanded Actions */}
      {expanded && (
        <div className="flex flex-col gap-2 items-end">
          {actions.map((action) => (
            <a
              key={action.id}
              href={action.href}
              target={action.external ? '_blank' : undefined}
              rel={action.external ? 'nofollow noreferrer' : undefined}
              className={`flex items-center gap-3 text-white pl-4 pr-5 py-3 rounded-full font-semibold text-sm transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-md ${action.bg}`}
              style={action.style}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${action.icon} text-lg`}></i>
              </span>
              {action.label}
            </a>
          ))}
        </div>
      )}

      {/* Toggle Button */}
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className={`w-14 h-14 flex items-center justify-center rounded-full text-white shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer ${
          expanded ? 'bg-gray-600 hover:bg-gray-700' : 'bg-brand-orange hover:bg-brand-orange-dark'
        }`}
      >
        <i className={`text-2xl transition-transform duration-300 ${expanded ? 'ri-close-line' : 'ri-customer-service-2-line'}`}></i>
      </button>
    </div>
  );
}
